import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const hWeb2 = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左

  // ウェブ縦
  const drawVerticalPath = () => {
    ctx.beginPath()
    ctx.moveTo(236, 245) // 左上＿左上
    ctx.quadraticCurveTo(240, 256, 240, 256) // 左上＿左下
    ctx.quadraticCurveTo(256, 238, 256, 238) // 中央＿左
    ctx.quadraticCurveTo(247, 267, 247, 267) // 左下＿左上
    ctx.quadraticCurveTo(255, 279, 255, 279) // 左下＿左下
    ctx.quadraticCurveTo(277, 239, 277, 239) // 左下＿右下
    ctx.quadraticCurveTo(276, 216, 276, 216) // 中央＿下
    ctx.quadraticCurveTo(297, 218, 297, 218) // 右下＿左上
    ctx.quadraticCurveTo(334, 179, 334, 179) // 右下＿右下
    ctx.quadraticCurveTo(330, 168, 330, 168) // 右下＿右上
    ctx.quadraticCurveTo(304, 177, 304, 177) // 中央＿右
    ctx.quadraticCurveTo(324, 145, 324, 145) // 右上＿右下
    ctx.quadraticCurveTo(317, 125, 317, 125) // 右上＿右上
    ctx.quadraticCurveTo(280, 161, 280, 161) // 右上＿左上
    ctx.quadraticCurveTo(267, 201, 267, 201) // 中央＿上
    ctx.quadraticCurveTo(249, 204, 249, 204) // 左上＿右上
    ctx.quadraticCurveTo(236, 245, 236, 245) // 左上＿左上
    ctx.fill()
    ctx.stroke()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawVerticalPath, webColor2)
  // ウェブ横1(先端)
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // ウェブ横2
  await middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10, printLeatherTypeValue)
  ctx.closePath()
  ctx.fillStyle = webColor

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 左辺
  ctx.moveTo(241, 250) // 上
  ctx.quadraticCurveTo(259, 233, 259, 233) // 中央＿左
  ctx.quadraticCurveTo(250, 268, 250, 268) // 下
  // 下辺
  ctx.moveTo(274, 231) // 上
  ctx.quadraticCurveTo(274, 213, 274, 213) // 中央＿上
  ctx.quadraticCurveTo(287, 214, 287, 214) // 下
  // 右辺
  ctx.moveTo(329, 171) // 上
  ctx.quadraticCurveTo(301, 180, 301, 180) // 中央＿右
  ctx.quadraticCurveTo(305, 167, 321, 144) //
  ctx.quadraticCurveTo(318, 134, 318, 134) //
  // 上辺
  ctx.moveTo(277, 178) // 上
  ctx.quadraticCurveTo(269, 203, 269, 203) // 下
  ctx.quadraticCurveTo(258, 205, 258, 205) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}

export const hJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  // ウェブ縦
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(266, 260) // 左＿上
  ctx.quadraticCurveTo(273, 275, 273, 275) // 左＿下
  ctx.quadraticCurveTo(319, 218, 319, 218) // 右＿下
  ctx.quadraticCurveTo(314, 190, 314, 190) // 右＿上
  ctx.quadraticCurveTo(284, 219, 266, 260) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // Hウェブ縦＿左＿外側
  ctx.moveTo(268, 260) // 上
  ctx.quadraticCurveTo(276, 273, 276, 273) // 下
  // // Hウェブ縦＿左＿内側
  ctx.moveTo(270, 257) // 上
  ctx.quadraticCurveTo(277, 270, 277, 270) // 下
  // // // Hウェブ縦＿右＿内側
  ctx.moveTo(308, 198) // 上
  ctx.quadraticCurveTo(313, 220, 313, 222) // 下
  // // // Hウェブ縦＿右＿外側
  ctx.moveTo(311, 194) // 上
  ctx.quadraticCurveTo(316, 219, 316, 219) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  // ウェブ横1(先端)
  topSidePartOfWebWithJoint(ctx, webColor, laceColor, stitchColor)
  // ウェブ横2
  middleSidePartOfWeb(ctx, webColor, stitchColor, 15, 35)
}
